var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (answer, i18n, isCorrect, isTooSlow, showLeftCol, timerPrompt) {
showLeftCol = answer.takeaway && ((isCorrect && answer.correct) || (!isCorrect && answer.incorrect) || answer.text)
buf.push("<div id=\"block-container\" class=\"block-h-md\"><div id=\"slide-answer-container\"" + (jade.cls(['row',showLeftCol ? "" : "split-column"], [null,true])) + "><div id=\"slide-answer-details\"" + (jade.cls(['col-sm-12','block-v-sm',showLeftCol ? "col-md-6" : "text-center"], [null,null,true])) + "><div class=\"content-scroll block-v-lg\"><p class=\"text-md\"><strong id=\"slide-answer-details-response\">");
if ( isTooSlow)
{
buf.push(null == (jade_interp = timerPrompt) ? "" : jade_interp);
}
else
{
buf.push(null == (jade_interp = isCorrect ? answer.correct : answer.incorrect) ? "" : jade_interp);
}
buf.push("</strong></p>");
if ( answer.text)
{
buf.push("<div id=\"slide-answer-details-text\" class=\"text-break text-md\">" + (null == (jade_interp = answer.text) ? "" : jade_interp) + "</div>");
}
buf.push("</div></div><div" + (jade.cls(['col-sm-12','block-v-lg',showLeftCol ? "col-md-6" : "text-center"], [null,null,true])) + ">");
if ( answer.takeaway)
{
buf.push("<div id=\"slide-answer-takeaway\"><h2 class=\"text-center text-break\">" + (null == (jade_interp = answer.takeaway) ? "" : jade_interp) + "</h2></div>");
}
buf.push("<div id=\"slide-answer-continue-container\"><div id=\"slide-answer-continue\" class=\"btn btn-block btn-solid\"> \n" + (jade.escape((jade_interp = i18n("buttons.continue")) == null ? '' : jade_interp)) + "</div></div></div></div></div>");}.call(this,"answer" in locals_for_with?locals_for_with.answer:typeof answer!=="undefined"?answer:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"isCorrect" in locals_for_with?locals_for_with.isCorrect:typeof isCorrect!=="undefined"?isCorrect:undefined,"isTooSlow" in locals_for_with?locals_for_with.isTooSlow:typeof isTooSlow!=="undefined"?isTooSlow:undefined,"showLeftCol" in locals_for_with?locals_for_with.showLeftCol:typeof showLeftCol!=="undefined"?showLeftCol:undefined,"timerPrompt" in locals_for_with?locals_for_with.timerPrompt:typeof timerPrompt!=="undefined"?timerPrompt:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}